import React, { useCallback, useEffect, useState } from "react";
import { coulmnsType, DictionaryType, tableConfig } from "../../types";
import Table from "../custom/tableWrapper/Table";
import SkeletonTable from "../skeletons/SkeletonTable";
import deleteIcon from "../../assets/icons/deleteRed.svg";
import editIcon from "../../assets/icons/EDIT ICON.svg";
import { useGetAvailableCourtsForEventQuery, useGetAvailableCourtsForTournamentQuery } from "../../lib/redux/services/sections/Leagues-Tournaments";
import {
  Controller,
  useFieldArray,
  UseFormSetValue,
  useWatch,
} from "react-hook-form";
import { checkSelectedCourts, cn } from "../../utils/utils";
import ModalButton from "../global/ModalButton";
import EditAvailableCourtsModel from "./EditAvailableCourtsModel";
import { FormType } from "./CreateForm";
import useMultiSelect from "../../hooks/useMultiSelect";
import Select from "react-select";
import { selectStyle, selectTheme } from "../../styles/selectStyles";

import { useGetDictionary } from "../../hooks/useGetDictionary";
import ErrorSection from "../global/ErrorSection";
import { toast } from "react-toastify";
import { Check } from "lucide-react";
type Props = {
  setAvailableCourtsLoading: any;
  availableCourtsLoading: boolean;
  availableCourtsParams: any;
  control: any;
  watch: any;
  isAllow: boolean;
  notAllowedToComplete: any;
  setNotAllowedToComplete: any;
  selectedCourts: any;
  setValue: UseFormSetValue<FormType> | any;
  setAvailableCourtsParams: any;
  setSelectedCourts: any;
  getValue: any;
  setMatchCount: any;
  setSelectedCourtsLength: any;
  selectedCourtsLength: number;

  type: "public" | "private";
};

const CourtSelection = ({
  control,
  setValue,
  priorityFields,
  available_Courts,
  selectedCourts,
  setSelectedCourts,
}: {
  control: any;
  setValue: any;
  priorityFields: any;
  available_Courts: any;
  selectedCourts: any;
  setSelectedCourts: any;
}) => {
  const { events, shared }: DictionaryType = useGetDictionary();
  const handleSelectChange = (selected: any, index: number, field: any) => {
    const selectedId = selected ? selected.id : null;

    // Update selected courts state
    setSelectedCourts((prev: any) => {
      const newSelected = { ...prev, [index]: selectedId };
      return newSelected;
    });

    // Update field value
    setValue(`courts_priority_ids.${index}.priority`, index + 1);
    field.onChange(selectedId);
  };

  const ORDER_ENUM = [
    { value: 1, label: shared.order.primary },
    { value: 2, label: shared.order.secondary },
    { value: 3, label: shared.order.third },
    { value: 4, label: shared.order.fourth },
    { value: 5, label: shared.order.fifth },
    { value: 6, label: shared.order.sixth },
    { value: 7, label: shared.order.seventh },
    { value: 8, label: shared.order.eighth },
    { value: 9, label: shared.order.ninth },
    { value: 10, label: shared.order.tenth },
  ];

  return (
    <>
      {priorityFields.map((item: any, index: number) => {
        // Get courts that are not selected in other fields
        const filteredOptions = available_Courts.filter(
          (court: any) =>
            !Object.values(selectedCourts).includes(court.id) ||
            selectedCourts[index] === court.id,
        );

        return (
          <div className="col-span-1 w-full flex-1" key={index}>
            <label className="block text-sm mb-2">
              {index < 10 ? ORDER_ENUM[index].label : `${index}th`}{" "}
              {events.court} <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              name={`courts_priority_ids.${index}.court_id`}
              rules={{ required: "Court type is required" }}
              render={({ field }) => (
                <Select
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  {...field}
                  styles={selectStyle}
                  classNamePrefix="react-select"
                  theme={selectTheme}
                  options={filteredOptions}
                  getOptionValue={(option: any) => option.id}
                  getOptionLabel={(option: any) => option.name}
                  onChange={(selected) =>
                    handleSelectChange(selected, index, field)
                  }
                  value={
                    filteredOptions.find(
                      (option: any) => option.id === field.value,
                    ) || null
                  }
                />
              )}
            />
          </div>
        );
      })}
    </>
  );
};

function AvailableCourtsTableNew({
  setAvailableCourtsLoading,
  availableCourtsLoading,
  availableCourtsParams,
  setNotAllowedToComplete,
  control,
  watch,
  notAllowedToComplete,
  isAllow,
    setSelectedCourtsLength,
  selectedCourtsLength,
  selectedCourts,
  setSelectedCourts,
  setValue,
  setMatchCount,
  setAvailableCourtsParams,
  type,
}: Props) {
  const { searchForItem } = useMultiSelect();
  const [available_Courts, setAvailableCourts] = useState<any>([]);

  const [selectedCourtsinPriority, setSelectedCourtsinPriority] = useState<{
    [key: number]: number | null;
  }>({});
  const test = useWatch({
    control,
    name: "available_courts",
  });
  const { events }: DictionaryType = useGetDictionary();
  const [availableCourtsData, setAvailableCourtsData] = useState<any>([]);
  // const required_courts = useWatch({ control, name: "required_courts" });
  const tournament_type = useWatch({ control, name: "tournament_type" });
  const max_players = useWatch({ control, name: "max_number_of_players" });
  // const priority = useWatch({ control, name: "courts_priority_ids" });
  const { fields: priorityFields } = useFieldArray({
    control,
    name: "courts_priority_ids",
  });
  //[TODO]
  const handleDelete = (id: number) => {
    // const newTest = watch("available_courts_ids").filter(
    //   (item: number) => item !== id
    // );

    // First get the current values safely
    const currentAvailableCourts = watch("available_courts_ids") || [];
    const currentUnwantedCourts = watch("unwanted_courts") || [];

    // Then update the values
    setValue(
      "available_courts_ids",
      currentAvailableCourts.filter((item: number) => item !== id),
    );
    setValue("unwanted_courts", [...currentUnwantedCourts, id]);
    setAvailableCourtsData((prev: any) =>
      prev.filter((item: any) => item.id !== id),
    );
    setSelectedCourts((prev: any) => {
      const newSelectedCourts = { ...prev };
      delete newSelectedCourts[id];
      setValue("available_courts", newSelectedCourts);
      return newSelectedCourts;
    });
    const not_allowed_lines = watch("not_allowed_lines") || [];
    if (not_allowed_lines.includes(id)) {
      setValue(
        "not_allowed_lines",
        not_allowed_lines.filter((item: any) => item !== id),
      );
    }
  };
  const getFunction = useGetAvailableCourtsForEventQuery;
  const { data, isLoading, isError, isFetching, isSuccess,error, refetch } =
    getFunction(availableCourtsParams, {
      skip: !availableCourtsLoading,
    });
  const handleSelect = (rowId: number, item: any) => {
    console.log(test);
    console.log(item);
    console.log(rowId);
    if (selectedCourts[rowId]) {
      console.log(test);
      console.log(item);
      console.log(rowId);
      const isFound = searchForItem(item, selectedCourts[rowId]) >= 0;
      if (isFound) {
        if (selectedCourts[rowId].length === 1) {
          setSelectedCourts((prev: any) => {
            const newSelectedCourts = { ...prev };
            delete newSelectedCourts[rowId];
            setValue("available_courts", newSelectedCourts);
            return newSelectedCourts;
          });
          setSelectedCourtsLength(selectedCourtsLength - 1);
        } else {
          setSelectedCourtsLength(selectedCourtsLength - 1);
          setSelectedCourts((prev: any) => {
            setValue("available_courts", {
              ...test,
              [rowId]: selectedCourts[rowId].filter(
                (court: any) => court.id !== item.id,
              ),
            });
            return {
              ...prev,
              [rowId]: prev[rowId].filter((court: any) => court.id !== item.id),
            };
          });
        }
      } else {
        if (selectedCourts[rowId].length >= Math.ceil(max_players / 4)) {
          return;
        }
        setSelectedCourtsLength(selectedCourtsLength + 1);
        setSelectedCourts((prev: any) => {
          setValue("available_courts", {
            ...test,
            [rowId]: [...test[rowId], item],
          });
          return {
            ...prev,
            [rowId]: [...prev[rowId], item],
          };
        });
      }
    } else {
      console.log(test);
      console.log(item);
      console.log(rowId);
setSelectedCourtsLength(selectedCourtsLength + 1);
      setSelectedCourts((prev: any) => ({
        ...prev,
        [rowId]: [item],
      }));
      setValue("available_courts", {
        ...test,
        [rowId]: [item],
      });
    }
  };

  const handleNotAllowed = useCallback(
    (result: boolean, rowData: any) => {
      if (!result) {
        //@ts-ignore
        const not_allowed_lines = watch("not_allowed_lines") || [];
        if (!not_allowed_lines.includes(rowData.id)) {
          setValue("not_allowed_lines", [...not_allowed_lines, rowData.id]);
        }
      } else {
        const not_allowed_lines = watch("not_allowed_lines") || [];
        if (not_allowed_lines.includes(rowData.id)) {
          setValue(
            "not_allowed_lines",
            not_allowed_lines.filter((item: any) => item !== rowData.id),
          );
        }
      }
    },
    [notAllowedToComplete],
  );

  // const {data,isLoading,isError,isFetching,isSuccess} =useGetAvailableCourtsForTournamentQuery(availableCourtsParams,{
  //   skip:!availableCourtsLoading
  // })
  useEffect(() => {
    if (data) {
      setMatchCount(data?.matches_count);
      setAvailableCourts([]);
      setSelectedCourts([]);
      setValue("available_courts", []);
      setValue("available_courts_ids", []);
      console.log(available_Courts);
      console.log(availableCourtsData);
      console.log(availableCourtsParams);
    }
    console.log();
  }, [data, isSuccess, isFetching, isLoading]);
  useEffect(() => {
    //setCourts(watch("court_ids"));
    if (isSuccess) {
      setValue(
        "available_courts_ids",
        data?.data?.map((item: any) => item.id),
      );
      //@ts-ignore
      let priorityObject = [];
      new Array(Math.ceil(max_players / 4))
        .fill(0)
        .forEach((item: any, index: number) => {
          //@ts-ignore
          priorityObject.push({
            court_id: 0,
            priority: index + 1,
          });
        });
      //@ts-ignore
      setValue(`courts_priority_ids`, priorityObject);

      setAvailableCourtsLoading(false);
    }
  }, [data, isSuccess]);
  useEffect(() => {
    if (available_Courts && data) {
      const courtsByPriority: { [key: number]: any } = {};
      new Array(Math.ceil(max_players / 4))
        .fill(0)
        .forEach((item: any, index: number) => {
          courtsByPriority[index + 1] = available_Courts;
        });
    }
  }, [available_Courts, data]);
  useEffect(() => {
    if (data) {
      if (watch("state") === "Draft") {
        setValue("available_courts", []);
      }
      setAvailableCourtsData([]);

      if (tournament_type) {
        data?.data?.forEach((item: any) => {
          setAvailableCourtsData((prev: any) => [...prev, item]);
        });
      }
      if (
        availableCourtsParams?.available_courts?.length === 0 ||
        !availableCourtsParams?.available_courts
      ) {
        setAvailableCourtsParams({
          ...availableCourtsParams,
          available_courts: data?.data?.map((item: any) => item.id),
        });
      }
      checkSelectedCourts(
        selectedCourts,
        availableCourtsData,
        setSelectedCourts,
        setSelectedCourtsLength,
        setValue,
      );
    } else {
      if (watch("state") === "Draft") {
        if (tournament_type) {
          data?.data?.forEach((item: any) => {
            setAvailableCourtsData((prev: any) => [...prev, item]);
          });
        }
        setAvailableCourtsData(watch("available_courts"));
        console.log(watch("available_courts"));
        setAvailableCourtsParams({
          ...availableCourtsParams,
          available_courts: watch("available_courts")?.map(
            (item: any) => item.id,
          ),
        });
        setValue(
          "available_courts_ids",
          watch("available_courts").map((item: any) => item.id),
        );
        setValue("available_courts", []);
      }
    }
    setSelectedCourtsinPriority({});
  }, [data]);
  useEffect(()=>{
      if((isError || error) && !isLoading && !isFetching){
        console.log(error);
       
    //@ts-ignore
    toast.error(error?.message || error?.error?.message ||error?.error || error?.data); 
        setAvailableCourtsLoading(false);
      }
  },[isError,isLoading,isFetching])
  if (isLoading || isFetching) {
    return <SkeletonTable />;
  }
  

  const columns: coulmnsType = [
     {
      title: events.available_courts_table?.round_number,
      tag: "line_number",
    },
    {
      title: "Day",
      tag: "day",
    },
    {
      title: events.available_courts_table?.timing,
      tag: "time",
    },
    {
      title:"slots",
      tag: "slots",
    },
    {
      title: events.available_courts_table?.available_courts,
      tag: "available_Courts",
    },
    
   
  ];

  const config: tableConfig = {
     line_number: {
      columnCellClassName: " w-[150px] min-w-[150px] max-w-[150px]",
      tdClassName: "w-[150px] min-w-[150px] max-w-[150px]",
      customClassName: "w-[150px] min-w-[150px] max-w-[150px]",
    },
    day: {
      columnCellClassName: " w-[100px] min-w-[100px] max-w-[100px]",
      tdClassName: "w-[100px] min-w-[100px] max-w-[100px]",
      customClassName: "w-[100px] min-w-[100px] max-w-[100px]",
    },
    time: {
      columnCellClassName: " w-[200px] min-w-[200px] max-w-[200px]",
      isCustomViewChildren: true,
      customViewChildren: (rowData, tag) => {
        return (
          <td className=" p-4 w-[200px] min-w-[200px] max-w-[200px] flex-1     relative cursor-pointer">
            <p className="text-primary dark:text-white  w-full">
              <strong className="pr-2">{rowData?.time}</strong>{" "}
            </p>
          </td>
        );
      },
    },

    available_Courts: {
      columnCellClassName: "*:justify-center",
      isCustomViewChildren: true,
      customViewChildren: (rowData, tag, setCurrentTrStyle) => {
        const availableCourts = rowData?.court_ids.map(
          (court: any) => court.id,
        );
        const isCorrect = () => {
          const result = Object.values(selectedCourtsinPriority).every(
            (court: any) => availableCourts.includes(court),
          );
          if (!result) {
            //@ts-ignore
            handleNotAllowed(result, rowData);
            setCurrentTrStyle && setCurrentTrStyle("bg-red-100");
          } else {
            //@ts-ignore
            handleNotAllowed(result, rowData);
            setCurrentTrStyle && setCurrentTrStyle("bg-none");
          }
        };
        isCorrect();
        if (tag === "available_Courts") {
          rowData?.court_ids.forEach((element: any) => {
            setAvailableCourts((prev: any) => {
              const isFound = searchForItem(element, prev);
              if (isFound > -1) {
                return prev;
              } else {
                return [...prev, element];
              }
            });
          });
        }
        const courts = rowData?.court_ids;

        return (
          <td className=" p-4 min-w-[240px] w-full flex-grow   relative cursor-pointer ">
            <div className="w-full flex justify-between">
              <div className="text-primary dark:text-white  w-fit flex gap-2 items-center  overflow-x-auto customScroll cursor-default pb-2 mx-auto">
                {courts.map((court: any) => {
                  return (
                    <span
                      key={court.id}
                      className={cn(
                        "p-2  ml-2 px-4   whitespace-nowrap cursor-pointer rounded-full ",
                        availableCourts.includes(court.id)
                          ? availableCourtsData.length > 0
                            ? "bg-[#E2F0E9] text-primaryGreen border border-[#A3DEB9] dark:text-white"
                            : "bg-[#B3D0FF3B] text-primary border border-[#7096FF]"
                          : " text-primaryRed bg-[#EF462624] border border-[#FF8E78C9] line-through",
                        selectedCourts[rowData.id] &&
                          selectedCourts[rowData.id]
                            ?.map((court: any) => court.id)
                            .includes(court.id) &&
                          "bg-[#B3D0FF3B] text-primary border border-[#7096FF]",
                        Object.values(selectedCourtsinPriority).includes(
                          court.id,
                        ) && "bg-[#B3D0FF3B] text-primary border border-[#7096FF]",
                      )}
                      onClick={() => {
                        if (
                          availableCourts.includes(court.id) &&
                          tournament_type !== "King of the Courts" &&
                          availableCourtsData.length > 0
                        ) {
                          handleSelect(rowData.id, court);
                        }
                      }}
                    >
                      <span className={cn("w-3 h-3 rounded-full bg-primaryRed inline-block mr-2",
                                              availableCourts.includes(court.id)
                                                ? availableCourtsData.length > 0
                                                  ? "bg-primaryGreen "
                                                  : "hidden "
                                                : " bg-primaryRed ",
                                              selectedCourts[rowData.id] &&
                                                selectedCourts[rowData.id]
                                                  ?.map((court: any) => court.id)
                                                  .includes(court.id) &&
                                                "hidden ",
                                            )}></span>
                                            
                                            {(selectedCourts[rowData.id] &&
                                                selectedCourts[rowData.id]
                                                  ?.map((court: any) => court.id)
                                                  .includes(court.id) || (availableCourts.includes(court.id) && availableCourtsData.length === 0)) && <Check className="text-primary inline-block mr-2" size={18} />}
                      {court.name}
                    </span>
                  );
                })}
              </div>
            </div>
          </td>
        );
      },
    },
     slots: {
       columnCellClassName: " w-[80px] min-w-[80px] max-w-[80px]",
      isCustomViewChildren: true,
      customViewChildren: (rowData, tag) => {
        return (
          <td className=" p-4 flex-1  w-[80px] min-w-[80px] max-w-[80px]     relative cursor-pointer">
            <p className="text-primary dark:text-white  w-full">
              <span className="pr-2">{watch('available_courts').length?Math.ceil(max_players / 4):(selectedCourts[rowData.id]?.length || 0)}/{Math.ceil(max_players / 4)}</span>
            </p>
          </td>
        );
      },
    }
  };

  console.log(availableCourtsData);
  console.log(watch("available_courts"));

  return (
    <div className="flex flex-col  w-full bg-white rounded-2xl p-4">
      {tournament_type === "King of the Courts" &&
        availableCourtsData.length > 0 && (
          <>
            <h3 className="font-bold text-lg text-primary dark:text-white pr-2">
              {events.court_ranking}
            </h3>

            <div className="grid grid-cols-4 gap-4 w-full">
              <CourtSelection
                control={control}
                setValue={setValue}
                priorityFields={priorityFields}
                available_Courts={available_Courts}
                selectedCourts={selectedCourtsinPriority}
                setSelectedCourts={setSelectedCourtsinPriority}
              />
            </div>
          </>
        )}
       <div className="w-full bg-[#F5F6F6] flex justify-between items-center pt-[18px] pb-[12px] px-6 rounded-t-2xl">
        <div className="flex gap-5 items-center">
          
          <div className="flex gap-2 items-center">
            <span className="w-3 h-3 rounded-full bg-primaryGreen"></span>{" "}
            {events.available}
          </div>
         
          <div className="flex gap-2 items-center">
            {" "}
            <span className="w-3 h-3 rounded-full bg-primary"></span>{" "}
            {events.selected}
          </div>
           <div className="flex gap-2 items-center">
            {" "}
            <span className="w-3 h-3 rounded-full bg-[#EF4626]"></span>{" "}
            {events.booked}
          </div>
        </div>
       
       </div>
      {data?.data?.length > 0 && availableCourtsData.length === 0 ? (
        <div className="text-center py-10 px-2 font-bold text-xl bg-red-100/80">
          {events.no_time_slot_have}{" "}
          <span className="text-red-500 text-2xl">
            {Math.ceil(max_players / 4)}
          </span>{" "}
          {events.courts}
        </div>
      ) : (
        <div className=" customer-table">
          <Table
            columnsData={
              availableCourtsData.length > 0
                ? columns
                : columns.filter(
                    (item: any) =>
                      item.tag !== "btns" && item.tag !== "round_number",
                  )
            }
            rowData={
              availableCourtsData.length > 0
                ? availableCourtsData
                : Object.keys(watch("available_courts")).length
                  ? watch("available_courts")
                  : []
            }
            tableClassName="border border-[#E1E6ED] rounded-t-none"
          generalCellColumnClassName="w-[150px] min-w-[150px] max-w-[150px] [&:nth-child(5)]:w-full [&:nth-child(5)]:flex-grow [&:nth-child(5)]:max-w-none  "
          generalCellRowClassName="  min-w-[150px] w-[150px] w-full overflow-hidden text-left flex-1"
          generalRowClassName=" text-left flex  w-full"
          generalColumnsClassName=" bg-white text-primary dark:text-white  static text-center items-left border-b border-gray-200 dark:border-slate-700 "
          config={config}
          />
        </div>
      )}

      
    </div>
  );
}

export default AvailableCourtsTableNew;
